import { render, staticRenderFns } from "./AllowanceDetailReportTable.vue?vue&type=template&id=3148024c"
import script from "./AllowanceDetailReportTable.vue?vue&type=script&lang=js"
export * from "./AllowanceDetailReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports